function overArg(e,n){return function(r){return e(n(r))}}module.exports=overArg;